module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-tomcat-02-jp.2bed0057de270c547910f73bb0d0a5df.png";